// ComponenteActualizarExistencias.jsx
import React from 'react';
import axios from 'axios';
import { usePermissions } from '../context/PermissionsContext';

const ComponenteActualizarExistencias = ({
  producto,
  idEmpleado,
  token,
  onSuccess,
  onError
}) => {
  const { hasPermission } = usePermissions();
  const canUpdateStock = hasPermission('productos.conteo.grabar');

  const handleClick = async () => {
    if (!canUpdateStock) return;
    const nuevaCantidad = prompt(
      `Especifica la nueva cantidad para "${producto.nombre_producto}":`
    );
    if (nuevaCantidad === null) return;

    try {
      // 1. Actualiza en la API
      await axios.put(
        '/api/productos/existencias',
        {
          idProducto: producto.id_producto,
          cantidad: nuevaCantidad,
          idEmpleado
        },
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      // 2. Llamar onSuccess para que el padre sepa la cantidad
      if (onSuccess) {
        onSuccess({ nuevaCantidad });
      }
    } catch (error) {
      console.error('Error al actualizar las existencias:', error);
      if (onError) onError(error);
    }
  };


  return (
    <div
      className={canUpdateStock ? "cursor-pointer" : "cursor-default"}
      onClick={handleClick}
      title={!canUpdateStock ? 'No tienes permiso para grabar conteo' : ''}
    >
      <span className={`font-bold px-3 py-1 rounded-full ${canUpdateStock ? 'bg-black-500 text-yellow-500 hover:bg-yellow-500 hover:text-black-500' : 'bg-gray-200 text-gray-500'}`}>
        {parseFloat(producto.existencias).toFixed(1)}
      </span>
    </div>
  );
};

export default ComponenteActualizarExistencias;
